import { factory, getResponseCamelization } from '@repo-level/core-front';
import {
  CMSApiBase,
  CMSGeneralButtonType,
  CMSGroupParams,
  CMSImageBase,
  CMSButtonParams,
  CMSScheduler,
  CMSOrder,
  LIMIT_500,
  buildCmsUrl,
  getResponseCMS,
} from './base';
import { isCMSV3 } from 'helpers/conf';

export interface Slide
  extends CMSApiBase,
    Omit<CMSButtonParams, 'buttonText'>,
    CMSGroupParams,
    CMSScheduler,
    CMSOrder {
  title: string;
  description: string;
  character: CMSImageBase;
  characterMobile: CMSImageBase;
  background: CMSImageBase;
  backgroundMobile: CMSImageBase;
  buttonType: CMSGeneralButtonType;
  buttonLink: string | null;
}

export const slidesV3 = factory((r) => (lang: string) =>
  r<Slide[]>(
    'get',
    buildCmsUrl({ path: 'slides-v-2-s', lang, limit: LIMIT_500 })
  )
);

export const slidesV4 = factory((r) => (lang: string) =>
  r<Slide[]>(
    'get',
    buildCmsUrl({
      path: 'slides-v-2-s',
      lang,
      limit: LIMIT_500,
      additionalParams: { populate: 'deep' },
    }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);

export const slides = isCMSV3 ? slidesV3 : slidesV4;
